export default Object.freeze({
  DEFAULT: 'DEFAULT',
  PRICE_ASC: 'PRICE_ASC',
  PRICE_DESC: 'PRICE_DESC',
  PRICE_PER_ASC: 'PRICE_PER_ASC',
  PRICE_PER_DESC: 'PRICE_PER_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SHELF_LIFE: 'SHELF_LIFE',
  CUSTOMER_RATING: 'CUSTOMER_RATING',
});
